import { SHOW_UNAUTHORIZED_MESSAGE } from "./actionType";

export const showUnauthorizedUserMessage = (data) => ({
  type: SHOW_UNAUTHORIZED_MESSAGE,
  payload: data,
});
